import React from 'react';
import { Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { localeFormatter, smevStatusOperation } from '../../../utils/formatters';
import { CHECK_STATUS } from '../../../configs';

export default function ApplicationLegend() {
  return (
    <div className="application-legend">
      <div className="legend-header">Легенда</div>
      <div className="legend-body">
        <div className="legend-column">
          <div className="f3">Статусы проверок </div>
          <div className="legend-statuses">
            {smevStatusOperation(CHECK_STATUS.PENDING)}
            {smevStatusOperation(CHECK_STATUS.SUCCESS)}
            {smevStatusOperation(CHECK_STATUS.FAILED)}
            {smevStatusOperation(CHECK_STATUS.ERROR)}
            {smevStatusOperation(CHECK_STATUS.DEFAULT)}
          </div>
        </div>
        <div className="legend-column">
          <div className="f3">Значение иконок</div>
          <div className="legend-icon-text">
            <Icons icon="full-screen" customIcon />Развернуть
          </div>
          <div className="legend-icon-text">
            <Icons icon="full-screen-close" customIcon />Свернуть
          </div>
          <div className="legend-icon-text">
            <Icons icon="download-2" customIcon />Скачать
          </div>
          <div className="legend-icon-text">
            <Icons icon="download-3" customIcon />Скачать с ЭЦП
          </div>
          <div className="legend-icon-text">
            <Icons icon="eye-fill" customIcon />Просмотреть
          </div>
          <div className="legend-icon-text">
            <Icons icon="update" customIcon />Заменить
          </div>
        </div>
      </div>
    </div>
  );
}
